import TextareaAutosize from "react-textarea-autosize";
import { AiFillCloseCircle } from "react-icons/ai";
import Switch from "react-switch";
import { permission_type } from "../../constants";
export default function Addemployee({
  setOpen,
  loading,
  account,
  permission,
  handleChange,
  handleChangePermission,
  create,
}) {
  const inputstyle = "border-2 border-gray-500 rounded-md";
  const pstyle = "text-sm font-Roboto tracking-wider font-bold";

  return (
    <div className="m-auto mt-4 shadow-xl p-10">
      <AiFillCloseCircle
        className="scale-150 cursor-pointer"
        onClick={() => setOpen(false)}
      />
      <div className="flex space-x-10 m-auto w-fit flex-wrap-reverse">
        <div className="flex space-x-4 ">
          <div className="flex flex-col space-y-4">
            <p className={pstyle}>FirstName</p>
            <p className={pstyle}>Last Name</p>
            <p className={pstyle}>Email</p>
            <p className={pstyle}>Mobile</p>
            <p className={pstyle}>Address</p>
          </div>
          <div className="flex flex-col space-y-2">
            <input
              type="text"
              className={inputstyle}
              value={account.firstname || ""}
              onChange={(e) => handleChange("firstname", e.target.value)}
            />
            <input
              type="text"
              className={inputstyle}
              value={account.lastname || ""}
              onChange={(e) => handleChange("lastname", e.target.value)}
            />
            <input
              type="email"
              className={inputstyle}
              value={account.email || ""}
              onChange={(e) => handleChange("email", e.target.value)}
            />
            <input
              type="mobile"
              className={inputstyle}
              value={account.mobile || ""}
              onChange={(e) => handleChange("mobile", e.target.value)}
            />
            <TextareaAutosize
              minRows={3}
              maxRows={6}
              className={inputstyle}
              value={account.address || ""}
              onChange={(e) => handleChange("address", e.target.value)}
            />
            <button
              className="bg-indigo-500 shadow-lg shadow-indigo-500/50 p-1 rounded-md  font-Roboto font-bold text-white "
              disabled={loading}
              onClick={create}
            >
              Submit employee
            </button>
          </div>
        </div>
        <div className="flex space-x-2">
          <div className="flex flex-col space-y-4">
            <p className={pstyle}>Add employee</p>
            <p className={pstyle}>Add user</p>
            <p className={pstyle}>View employee</p>
            <p className={pstyle}>view user</p>
            <p className={pstyle}>edit employee</p>
            <p className={pstyle}>edit user</p>
            <p className={pstyle}>View employee List</p>
            <p className={pstyle}>view user List</p>
          </div>
          <div className="flex flex-col space-y-2">
            <Switch
              onChange={(e) =>
                handleChangePermission(permission_type.CREATE_EMPLOYEE, e)
              }
              checked={permission[permission_type.CREATE_EMPLOYEE]}
              disabled={loading}
            />
            <Switch
              onChange={(e) =>
                handleChangePermission(permission_type.CREATE_USER, e)
              }
              checked={permission[permission_type.CREATE_USER]}
              disabled={loading}
            />
            <Switch
              onChange={(e) =>
                handleChangePermission(permission_type.VIEW_EMPLOYEE, e)
              }
              checked={permission[permission_type.VIEW_EMPLOYEE]}
              disabled={loading}
            />
            <Switch
              onChange={(e) =>
                handleChangePermission(permission_type.VIEW_USER, e)
              }
              checked={permission[permission_type.VIEW_USER]}
              disabled={loading}
            />
            <Switch
              onChange={(e) =>
                handleChangePermission(permission_type.EDIT_EMPLOYEE, e)
              }
              checked={permission[permission_type.EDIT_EMPLOYEE]}
              disabled={loading}
            />
            <Switch
              onChange={(e) =>
                handleChangePermission(permission_type.EDIT_USER, e)
              }
              checked={permission[permission_type.EDIT_USER]}
              disabled={loading}
            />
            <Switch
              onChange={(e) =>
                handleChangePermission(permission_type.VIEW_EMPLOYEE_LIST, e)
              }
              checked={permission[permission_type.VIEW_EMPLOYEE_LIST]}
              disabled={loading}
            />
            <Switch
              onChange={(e) =>
                handleChangePermission(permission_type.VIEW_USER_LIST, e)
              }
              checked={permission[permission_type.VIEW_USER_LIST]}
              disabled={loading}
            />
          </div>
          <div></div>
        </div>
      </div>
    </div>
  );
}
